var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotosmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83 11h4.34C9.87 11 11 9.81 11 8.04V3.96C11 2.19 9.86 1 8.17 1H3.83C2.13 1 1 2.19 1 3.96v4.08C1 9.81 2.14 11 3.83 11Zm.42-5.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM9.9 7.47c.17.43.08.94-.1 1.37-.21.5-.62.89-1.13 1.05-.23.08-.46.11-.7.11H3.76c-.41 0-.79-.1-1.09-.29-.2-.12-.22-.39-.08-.56l.7-.89c.45-.57.75-.73 1.09-.59.13.06.27.15.41.24.38.26.9.61 1.59.23.47-.26.74-.71.98-1.1v-.01l.05-.09.25-.38c.1-.15.52-.62 1.06-.29.34.22.63.5.93.8.12.12.2.25.26.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosmall);
export default __webpack_public_path__ + "static/media/photo.small.5ba3575796475e40e2b01ab676a17fab.svg";
export { ForwardRef as ReactComponent };